export var giveMeHyperlink = function (_a) {
    var text = _a.text, url = _a.url, _b = _a.openNewTab, openNewTab = _b === void 0 ? true : _b;
    if (text === '' || url === '') {
        return text;
    }
    return "<a href='".concat(url, "' target='").concat(openNewTab ? '_blank' : '_self', "'>").concat(text, "</a>");
};
//# sourceMappingURL=index.js.map